module.exports = __webpack_public_path__ + "img/sym2.c5bcbde7.png";